<ng-container *ngIf="loading; else tourRoute">
  <div class="loading">
    <mat-spinner color="primary" diameter="24"></mat-spinner>
  </div>
</ng-container>
<ng-template #tourRoute>
  <div class="d-flex">
    <div *ngIf="storingDragDrop" class="storing-drag-drop-overlay">
      <div class="overlay-spinner">
        <mat-spinner color="primary" diameter="75"></mat-spinner>
      </div>
    </div>
    <div
      cdkDropList
      [cdkDropListData]="tour.tourItems"
      [cdkDropListDisabled]="tour.routeChecked"
      (cdkDropListDropped)="onListDrop($event)"
      class="flex-0-4875"
    >
      <div
        *ngFor="
          let tourItem of tour.tourItems;
          let i = index;
          trackBy: trackById
        "
        class="flex"
        cdkDrag
        [cdkDragData]="tourItem"
      >
        <div class="index-display">
          <div class="index-display-inner">{{ i + 1 }}</div>
        </div>
        <div
          cdkDragHandle
          class="smaller-left-space tour-item-block clickable"
          [ngClass]="tourItem.tourItemBackgroundClass"
        >
          <ng-container *ngIf="tourItem.subProject != null">
            <div class="d-flex">
              <div class="flex-0-6 block-text width-0">
                <ng-container
                  *ngIf="
                    tourItem.subProject?.project?.involvedCompanies?.length > 0
                  "
                >
                  <div
                    *ngFor="
                      let company of tourItem.subProject.project
                        .involvedCompanies
                    "
                    class="strong ellipsis"
                  >
                    {{ company.regularName }}
                  </div>
                </ng-container>
                <div class="secondary-color ellipsis">
                  {{
                    tourItem.subProject?.projectPlacement?.address?.line1
                      | printAddress
                        : tourItem.subProject?.projectPlacement?.address
                            ?.postalCode
                        : tourItem.subProject?.projectPlacement?.address?.city
                  }}
                </div>
                <ng-container
                  *ngIf="tourItem.subProject?.project?.products?.length > 0"
                >
                  <div
                    *ngFor="let product of tourItem.subProject.project.products"
                  >
                    {{ product | productPlacementConfig: 0 }}
                  </div>
                </ng-container>
              </div>
              <div class="flex-0-3 block-text">
                <div class="horizontal-center">
                  {{
                    tourItem.subProject?.currentRequestDate
                      | printASAPDateFormat
                        : tourItem.subProject?.currentRequestASAP
                        : 'dd/MM/yyyy'
                  }}
                </div>
                <div>
                  <div
                    *ngIf="
                      tourItem.subProject?.projectPlacement?.appointment ||
                      tourItem.subProject?.projectPlacement?.collectKey
                    "
                    class="d-flex in-the-middle"
                  >
                    <ng-container
                      *ngIf="
                        tourItem.subProject.projectPlacement.appointment &&
                          !tourItem.subProject.projectPlacement.collectKey;
                        else keyAppointment
                      "
                    >
                      <div class="strong secondary-color">
                        {{
                          tourItem.subProject.appointmentTime | shortenText: 20
                        }}
                      </div>
                    </ng-container>
                    <ng-template #keyAppointment>
                      <img
                        class="key-icon"
                        src="../../../../../../assets/collect-key.png"
                      />
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="flex-0-1 block-text">
                <div class="d-flex flex-end type-display-container">
                  <div
                    class="type-display-content in-the-middle"
                    [ngClass]="tourItem.subProject.typeClass"
                  >
                    <span>{{ tourItem.subProject.typeDisplay }}</span>
                  </div>
                </div>
                <div class="horizontal-center mt-1">
                  <div>#{{ tourItem.subProject?.project?.id }}</div>
                  <div
                    *ngIf="tourItem.subProject?.project?.oldPlatformId != null"
                    class="font-weight-bold font-italic"
                    [matTooltip]="'Jobnummer oud platform'"
                  >
                    ({{ tourItem.subProject.project.oldPlatformId }})
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="tourItem.immoTask != null">
            <div class="d-flex">
              <div class="flex-0-6 block-text">
                <div
                  *ngIf="tourItem.immoTask.requestingUser != null"
                  class="strong"
                >
                  {{
                    tourItem.immoTask.requestingUser.firstName
                      | personName: tourItem.immoTask.requestingUser.lastName
                  }}
                </div>
                <div class="secondary-color">
                  {{
                    tourItem.immoTask.address?.line1
                      | printAddress
                        : tourItem.immoTask.address?.postalCode
                        : tourItem.immoTask.address?.city
                  }}
                </div>
              </div>
              <div class="flex-0-3 block-text">
                <div class="horizontal-center">
                  {{
                    tourItem.immoTask.requestedDate
                      | printASAPDateFormat
                        : tourItem.immoTask.requestedASAP
                        : 'dd/MM/yyyy'
                  }}
                </div>
                <div class="d-flex in-the-middle">
                  <div
                    *ngIf="tourItem.immoTask.executionTime != null"
                    class="strong secondary-color"
                  >
                    {{ tourItem.immoTask.executionTime | slice: 0:5 }}
                  </div>
                </div>
              </div>
              <div class="flex-0-1 block-text">
                <div class="d-flex flex-end type-display-container">
                  <div class="type-display-content in-the-middle immo-task">
                    <span>Taak</span>
                  </div>
                </div>
                <div class="horizontal-center mt-1">
                  <div>#{{ tourItem.immoTask.id }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="flex-0-025"></div>
    <div class="flex-0-4875">
      <immo-ip-placer-tour-route-map
        [tour]="tour"
        [tourDateChangedOrDestroy]="tourDateChangedOrDestroy"
        [rerenderMap]="rerenderMap"
      ></immo-ip-placer-tour-route-map>
    </div>
  </div>
</ng-template>
